import { atom } from "recoil";

export const LOADING = atom<boolean>({
    key: 'loader',
    default: false
});

export const EDITING = atom<boolean>({
    key: 'editing',
    default: false
});


